import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClassificacaoFilter } from '../../filter';
import { ClassificacaoTipo } from '../classificacao-tipo';

@Injectable({
    providedIn: 'root'
})
export class ClassificacaoTipoHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                private configServerService: ConfigServerService) {
        this.pathApi = `${this.configServerService.getPathApi()}/classificacao/0/tipo`
    }

    /** Pesquisa as classificações agrupadas pelos seus tipos */
    search(filter: ClassificacaoFilter): Observable<ClassificacaoTipo[]> {
        // Params
        let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClassificacaoTipo[]>(this.pathApi, {params});
    }
}
